export default __webpack_public_path__ + "static/media/risks.a13e5b23.jpg";